var _g, _g2, _g3, _g4, _path, _text, _g5, _g6, _g7, _g8, _g9, _g10, _text2, _g11, _g12, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollOfDumpsterTruckWithTrailer1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 675 243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M32.019 201.75h532.114",
    "data-name": "Line 60"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m34.062 206.25-12.261-4.5 12.261-4.5Z",
    "data-name": "Path 88"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m561.932 206.25 12.261-4.5-12.261-4.5Z",
    "data-name": "Path 89"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.5 6.5v165.8",
    "data-name": "Line 62"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "M0 7.8 4.5 0 9 7.8Z",
    "data-name": "Path 92"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m0 171 4.5 7.8L9 171Z",
    "data-name": "Path 93"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 69"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m576.868 177.86 21.2-34.862",
    "data-name": "Line 63"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m581.455 179.06-7.915 4.392.187-8.972Z",
    "data-name": "Path 94"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m601.232 146.475.187-8.972-7.84 4.273Z",
    "data-name": "Path 95"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-926.818 -6332.797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M261.043 202.696a2 2 0 0 1 3.4 0l6.914 11.194a2 2 0 0 1-1.7 3.051h-13.828a2 2 0 0 1-1.7-3.051Z",
    "data-name": "Polygon 6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    "data-name": "L,L m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(232.742 234.203)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "L,L m"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 125",
    transform: "translate(-555.506 -6374.74)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.814 6547.788a2 2 0 0 1 .802 2.204l-5.854 20.574a2 2 0 0 1-3.806.132l-11.848-32.568a2 2 0 0 1 3-2.344Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "W,W m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(600.494 192.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "W,W m")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "var(--delivery-measurement-color)",
    "data-name": "Group 124",
    transform: "translate(-1133.601 -6535.225)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 33,
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.798 6556.71a2 2 0 0 1 2.204-.8l20.574 5.853a2 2 0 0 1 .132 3.806l-32.568 11.848a2 2 0 0 1-2.344-3Z",
    "data-name": "Polygon 2"
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "H,H m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(26.066 28.538)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "H,H m")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    "data-name": "Group 8",
    transform: "translate(-4334.899 -3774.43)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M4567.166 3886.754v-52.933h-197.96v52.933l14.631 12.51h168.869Z",
    "data-name": "Path 82"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4434.686 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 26",
    transform: "translate(4374.285 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4444.786 3921.661)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 29",
    transform: "translate(4384.386 3921.661)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4417.285 3938.36h20m-20 0h20",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M4413.886 3922.661h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4522.316 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4532.417 3921.661)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 25",
    transform: "translate(4522.316 3911.561)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    strokeMiterlimit: 10,
    strokeWidth: 5,
    "data-name": "Ellipse 28",
    transform: "translate(4532.417 3921.661)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M4477.439 3922.661h44.877",
    "data-name": "Path 10"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M4564.487 3922.661h13.834v-15.972h-217",
    "data-name": "Path 11"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4417.285 3938.36h20m-21.399 0h18",
    "data-name": "Line 59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M4361.317 3906.689v15.673h13.992",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m4575.713 3930.95 23.885-9.639a3.528 3.528 0 0 1 4.296 2.522 3.528 3.528 0 0 1-2.521 4.296l-25.867 10.408",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3.351,
    d: "M4614.933 3922.742c4.205-5.706-4.166-9.604-5.185-3.59-.787 4.503-6.007 4.518-6.007 4.518",
    "data-name": "Path 83"
  })), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M4565.543 3938.36h10.324v-15",
    "data-name": "Path 13"
  }), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5,
    d: "M4477.439 3938.36h45.061",
    "data-name": "Line 59"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "var(--delivery-color)",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    transform: "translate(-34.039 -31.748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.096 185.2v-24.4",
    "data-name": "Line 54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.997 185.2h78.091v4.7c.007 3.31 1.832 5.99 4.085 6h5.106",
    "data-name": "Path 76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 185.2h22",
    "data-name": "Line 55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.727 197.378h16.812c2.971 0 5.379-3.009 5.379-6.721v-45.741a14.97 14.97 0 0 0-1.445-6.52l-25.05-53.164a5.357 5.357 0 0 0-4.657-3.31h-41.348c-2.971 0-5.379 3.009-5.379 6.721v78.944H318.554c-2.128 0-3.854 2.156-3.854 4.815v8.12c0 2.659 1.725 4.815 3.854 4.815H339",
    "data-name": "Path 77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 24",
    transform: "translate(530.72 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 25",
    transform: "translate(400.4 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.8,
    cy: 21.8,
    r: 21.8,
    "data-name": "Ellipse 26",
    transform: "translate(338 171.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 27",
    transform: "translate(540.82 181.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 28",
    transform: "translate(410.5 181.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7,
    cy: 11.7,
    r: 11.7,
    "data-name": "Ellipse 29",
    transform: "translate(348.1 181.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.902 112.1h-29.627c-3.282 0-5.943 3-5.943 6.7v13.5c0 3.7 2.661 6.7 5.943 6.7h43.643",
    "data-name": "Path 78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.282 149.1h-20.071a9.836 9.836 0 0 0-6.849 2.7l-15.8 15.7",
    "data-name": "Path 80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381 198.4h20",
    "data-name": "Line 59"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M440.67 114.256V61.323H269.094v52.933l12.681 12.51h146.364Z",
    "data-name": "Path 82"
  }), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    "data-name": "Group 3",
    transform: "rotate(-20 -7282.395 13619.937)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 5.9,
    r: 5.9,
    strokeWidth: 5.027,
    "data-name": "Ellipse 23",
    transform: "translate(4629.886 3532.353)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5.027,
    d: "m4632.244 3543.829-8.337 7.122a3.528 3.528 0 0 1-4.9-.9 3.528 3.528 0 0 1 .9-4.9l10.4-8.417",
    "data-name": "Path 79"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 3.351,
    d: "M4608.186 3554.851c-2 6.8 7.2 7.6 6.1 1.6-.8-4.5 4.1-6.3 4.1-6.3",
    "data-name": "Path 83"
  })), /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 5.027,
    d: "M476.955 116.845v-11.288a3.213 3.213 0 0 0-3.207-3.306l-6.58.025a3.08 3.08 0 0 0-3.116 3.148v10.869",
    "data-name": "Path 81"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 5.027,
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    d: "M474.063 102.51V73.508",
    "data-name": "Line 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.708 101.87V77.126",
    "data-name": "Line 57"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M278.213 190.351h285.079",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m280.037 194.851-10.943-4.5 10.943-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m561.468 194.851 10.8-4.5-10.8-4.5Z",
    "data-name": "Path 91"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-760.038 -6337.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M427.787 191.919a2 2 0 0 1 1.735-1.329 2 2 0 0 1 1.736 1.329l7.057 15.724a3.739 3.739 0 0 1 .046 2.844 2.046 2.046 0 0 1-1.782 1.442h-14.114a2.046 2.046 0 0 1-1.782-1.442 3.739 3.739 0 0 1 .046-2.844Z",
    "data-name": "Polygon 6"
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    "data-name": "B,B m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(402.523 228.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "B,B m"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--delivery-color)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M30.92 190.351h212.002",
    "data-name": "Line 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m32.744 194.851-10.943-4.5 10.943-4.5Z",
    "data-name": "Path 90"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-color)",
    d: "m241.098 194.851 10.8-4.5-10.8-4.5Z",
    "data-name": "Path 91"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 145",
    transform: "translate(-1065.038 -6337.81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.121,
    height: 33.49,
    fill: "var(--delivery-measurement-color)",
    "data-name": "Rectangle 1",
    rx: 10,
    transform: "translate(1148 6543)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "var(--delivery-measurement-color)",
    d: "M122.787 191.919a2 2 0 0 1 1.735-1.329 2 2 0 0 1 1.736 1.329l7.057 15.724a3.739 3.739 0 0 1 .046 2.844 2.046 2.046 0 0 1-1.782 1.442h-14.114a2.046 2.046 0 0 1-1.782-1.442 3.739 3.739 0 0 1 .046-2.844Z",
    "data-name": "Polygon 6"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    "data-name": "S,S m",
    fontFamily: "HKGrotesk-SemiBold, HK Grotesk",
    fontSize: 21.781,
    fontWeight: 600,
    transform: "translate(97.523 228.649)"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "var(--delivery-measurement-inside-color)",
    x: 0,
    y: 0
  }, "S,S m"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollOfDumpsterTruckWithTrailer1);
export default __webpack_public_path__ + "static/media/RollOfDumpsterTruckWithTrailer1.593b078c277d0874f5dc9682c28c62bb.svg";
export { ForwardRef as ReactComponent };